<div *ngIf="person" class="flex flex-column align-items-center align-content-center gap-4 my-5 m-auto w-10">
    <h2>{{ person.name }}</h2>
    <div class="border-1 px-3 py-1 surface-border">
        <h3>Crear suscripción</h3>
        <form [formGroup]="subscriptionForm" (ngSubmit)="createSubscription()"
            class="flex flex-row gap-5 align-items-center">
            <div class="field mb-5 w-3">
                <span class="p-float-label">
                    <p-dropdown formControlName="subscription" inputId="subscription" [options]="subscriptionList"
                        optionLabel="name" styleClass="w-full p-inputtext-lg" placeholder="Plan"
                        emptyMessage="No hay registros"></p-dropdown>
                    <label htmlFor="subscription">Plan</label>
                </span>
            </div>
            <div class="field mb-5 w-3">
                <span class="p-float-label">
                    <input type="text" id="days" pInputText class="p-inputtext-lg w-full" formControlName="days"
                        maxlength="3" />
                        <label htmlFor="days">Días</label>
                </span>
            </div>
            <div class="field mb-5">
                <span class="p-float-label">
                    <textarea rows="3" cols="30" id="additionalNotes" pInputTextarea class="p-inputtext-lg w-full" maxlength="100"
                        formControlName="additionalNotes"></textarea>
                    <label htmlFor="additionalNotes">Detalle (opcional)</label>
                </span>
                <label class="contador">{{ this.subscriptionForm.get('additionalNotes')?.value.length }}/100</label>
            </div>
            <p-button label="Crear" type="sumbit" [loading]="loading" [disabled]="subscriptionForm.invalid || loading"></p-button>
        </form>
    </div>
    <p-divider class="w-full"></p-divider>
    <h3>Historial de suscripciones</h3>
    <app-create-payment [(displayDialog)]="displayCreatePayment" (createdChange)="paymentCreatedListener($event)" [subscriptionDetail]="subscriptionSelected"></app-create-payment>
    <div class="m-auto">
        <p-table *ngIf="person.subscriptionDetails?.length" #dt1 [value]="person.subscriptionDetails!"
            styleClass="p-datatable-gridlines" [scrollable]="true" [paginator]="true" [rows]="15"
            [tableStyle]="{'min-width': '5rem'}" sortField="endDate" [sortOrder]="-1">
            <ng-template pTemplate="header">
                <tr>
                    <th class="cabecera">
                        Suscripción
                    </th>
                    <th class="cabecera">
                        Fecha de suscripción
                    </th>
                    <th class="cabecera">
                        Fecha de inicio de suscripción
                    </th>
                    <th class="cabecera">
                        Fecha vencimiento suscripción
                    </th>
                    <th class="cabecera">
                        Información adicional
                    </th>
                    <th class="cabecera">
                        Suscripción activa
                    </th>
                    <th class="cabecera">
                        Pago
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-subscriptionDetail let-index="rowIndex">
                <tr [ngClass]="{ 'fondo-registro' : index % 2 !== 0 }">
                    <td>
                        <p>{{ subscriptionDetail.subscription.name }}</p>
                    </td>
                    <td>
                        <p>{{ subscriptionDetail.issueDate | date:'yyyy-MM-dd HH:mm:ss' }}</p>
                    </td>
                    <td>
                        <p [ngClass]="{'text-green-600': subscriptionDetail.beginDate > currentDate}">{{
                            subscriptionDetail.beginDate | date:'yyyy-MM-dd HH:mm:ss' }}</p>
                    </td>
                    <td>
                        <p [ngClass]="{'text-red-600': subscriptionDetail.endDate <= currentDate}">{{
                            subscriptionDetail.endDate | date:'yyyy-MM-dd HH:mm:ss' }}</p>
                    </td>
                    <td>
                        <p>{{ subscriptionDetail.additionalNotes }}</p>
                    </td>
                    <td>
                        <p [ngClass]="subscriptionDetail.active ? 'text-green-600' : 'text-red-600'">{{
                            subscriptionDetail.active ? 'Sí' : 'No' }}</p>
                    </td>
                    <td>
                        <p class="m-0 p-0" *ngIf="subscriptionDetail.payment">
                            {{ subscriptionDetail.payment.payDate | date:'yyyy-MM-dd' }}
                        </p>
                        <p class="m-0 p-0" *ngIf="subscriptionDetail.payment">
                            {{ subscriptionDetail.payment.method }}:
                            {{ subscriptionDetail.payment.amount | number: '1.0-0' : 'co' }} {{ subscriptionDetail.payment.currency }}
                        </p>
                        <p class="text-sm" *ngIf="subscriptionDetail.payment">
                            {{ subscriptionDetail.payment.additionalInfo }}
                        </p>
                        <p-button *ngIf="!subscriptionDetail.payment" label="Registrar pago" icon="pi pi-wallet" (onClick)="createPayment(subscriptionDetail)" 
                            ariaLabel="Registrar pago" ></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>